/**
 * Named keys rather than the entity name: the tab is this template's own view of those rows, and the
 * entity name is already the board's.
 */
export const JobTemplateRelationName = {
  Items: 'items',
  Tasks: 'tasks',
  Questions: 'questions',
} as const;
